var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div data-behavior=\"toggle-children\">\n"
    + ((stack1 = container.invokePartial(require("../../partials/range.hbs"),depth0,{"name":"../../partials/range","data":data,"indent":"\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n<ul class=\"evaluation-collection--children evaluations-hidden\" data-behavior=\"child-container\">\n</ul>\n";
},"usePartial":true,"useData":true});